export default __webpack_public_path__ + "static/koo-9f3a021ec3e36064a20afc3419fd339d.svg";